/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSimulationAssignmentRequestBody
 */
export interface UpdateSimulationAssignmentRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSimulationAssignmentRequestBody
     */
    newAssignedToId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSimulationAssignmentRequestBody
     */
    message?: string | null;
}

/**
 * Check if a given object implements the UpdateSimulationAssignmentRequestBody interface.
 */
export function instanceOfUpdateSimulationAssignmentRequestBody(value: object): value is UpdateSimulationAssignmentRequestBody {
    if (!('newAssignedToId' in value) || value['newAssignedToId'] === undefined) return false;
    return true;
}

export function UpdateSimulationAssignmentRequestBodyFromJSON(json: any): UpdateSimulationAssignmentRequestBody {
    return UpdateSimulationAssignmentRequestBodyFromJSONTyped(json, false);
}

export function UpdateSimulationAssignmentRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSimulationAssignmentRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'newAssignedToId': json['newAssignedToId'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function UpdateSimulationAssignmentRequestBodyToJSON(json: any): UpdateSimulationAssignmentRequestBody {
    return UpdateSimulationAssignmentRequestBodyToJSONTyped(json, false);
}

export function UpdateSimulationAssignmentRequestBodyToJSONTyped(value?: UpdateSimulationAssignmentRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newAssignedToId': value['newAssignedToId'],
        'message': value['message'],
    };
}

